import axios, { AxiosRequestConfig } from 'axios'
import { fetchAuthSession, signOut } from 'aws-amplify/auth'
// export const api_baseURL = `https://virtserver.swaggerhub.com/SIMON_11/TibimediaCustomerAPI/1.0.0`

// @ts-ignore
// axios.defaults.proxy.host = 'https://api.klanten-test.tibimedia.nl'
const isDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
export const api_baseURL = isDevelopment ? `/api` : process.env.REACT_APP_API_URL

const redirectToLogin = async () => {
    try {
        await signOut()
    } catch (_) {}
    window.location.replace('/login')
}

const PUBLIC_PATHS = ['/login', '/reset-password', '/consumer/confirm-order']
const isOnPublicPage = () => PUBLIC_PATHS.some((p) => window.location.pathname.startsWith(p))

// Redirect to login on any 401 response from the API (except on public pages)
axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.response?.status === 401 && !isOnPublicPage()) {
            await redirectToLogin()
        }
        return Promise.reject(error)
    }
)

const doRequest = async (config: AxiosRequestConfig, authorizationEnabled: boolean = true) => {
    const defaultConfig: AxiosRequestConfig = {
        //Authentication configuration goes here
        // cors
    }

    const headers: Record<string, string> = {
        ...((defaultConfig.headers as Record<string, string> | undefined) ?? {}),
        ...((config.headers as Record<string, string> | undefined) ?? {})
    }

    if (authorizationEnabled) {
        let currentSession
        try {
            currentSession = await fetchAuthSession()
        } catch (_) {
            // fetchAuthSession throws when the refresh token is expired
            await redirectToLogin()
            return Promise.reject(new Error('Session expired'))
        }

        if (currentSession.tokens?.idToken) {
            // Authorization: `Bearer ${currentSession.getIdToken().getJwtToken()}`
            // Authorization: `Bearer ${currentSession.getAccessToken().getJwtToken()}`
            headers.Authorization = `Bearer ${currentSession.tokens.idToken}`
        } else {
            // fetchAuthSession returned without tokens — session is gone
            await redirectToLogin()
            return Promise.reject(new Error('Session expired'))
        }
    }

    return axios({
        ...{
            ...defaultConfig,
            ...config,
            headers: headers
        }
    })
}

export const get = (route: string, config?: AxiosRequestConfig) => {
    return doRequest({
        method: 'GET',
        url: api_baseURL + route,
        ...config
    })
}

export const put = (route: string, config: AxiosRequestConfig) => {
    return doRequest({
        method: 'PUT',
        url: api_baseURL + route,
        ...config
    })
}

export const post = (route: string, config: AxiosRequestConfig) => {
    return doRequest({
        method: 'POST',
        url: api_baseURL + route,
        ...config
    })
}

export const getPublic = (route: string, config?: AxiosRequestConfig) => {
    return doRequest(
        {
            method: 'GET',
            url: api_baseURL + route,
            ...config
        },
        false
    )
}

export const postPublic = (route: string, config: AxiosRequestConfig) => {
    return doRequest(
        {
            method: 'POST',
            url: api_baseURL + route,
            ...config
        },
        false
    )
}

export const remove = (route: string, config: AxiosRequestConfig) => {
    return doRequest({
        method: 'REMOVE',
        url: api_baseURL + route
    })
}

export const del = (route: string, config?: AxiosRequestConfig) => {
    return doRequest({
        method: 'DELETE',
        url: api_baseURL + route,
        ...config
    })
}
